<template>
  <div class="new-top-bar-wrapper">
    <slot name="left" />
    <slot name="right" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NewTopbarWrapper',
});
</script>

<style lang="scss" scoped>
@import './scss/dsr-variables';

.new-top-bar-wrapper {
  height: $new-top-bar-height;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-100);
  border-bottom: 1px solid var(--gray-96);
  background: var(--white);
  position: relative;
}
</style>
